export default (api) => {
  for(const callback of window.kernel.realApi) {
    callback(api)
  }
}